<template>
  <div>
    <div id="reviews-by-rating-by-month-chart" class="w-full" />
    <TheNoResult
      v-if="noData"
      :image="imgUrl"
      :title="$t('pages.review.reviewAnalyticsPage.chart.noResults.title')"
      :description="$t('pages.review.reviewAnalyticsPage.chart.noResults.description')"
    />
  </div>
</template>

<script>
import TheNoResult from '@/components/layout/TheNoResult.vue'
import { StackedColumnChart } from '@/components/charts/StackedColumnChart'
import ApexChart from 'apexcharts'
import useReview from '@/composables/review'

export default {
  name: 'ReviewsByRatingMonthChart',
  components: {
    TheNoResult
  },
  setup() {
    const { reviewStatistics } = useReview()
    const imgUrl = computed(() => `${import.meta.env.VITE_AWS_STORAGE_URL}/review-analytics/review-total.png`)

    return {
      reviewStatistics,
      imgUrl
    }
  },
  data: () => {
    return {
      chartInstance: null,
      chart: new StackedColumnChart(),
      categories: [],
      formattedData: []
    }
  },
  computed: {
    noData() {
      return (
        this.formattedData[0]?.data.length === 0 &&
        this.formattedData[1]?.data.length === 0 &&
        this.formattedData[2]?.data.length === 0
      )
    },
    data() {
      return this.reviewStatistics.countReviewsByRatingByMonth
    }
  },
  mounted() {
    this.initChart()
  },
  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy()
    }
  },
  methods: {
    resolveMoodLabelBySlug(slug) {
      return this.$t(`pages.review.reviewSettingsPage.templates.form.mood.${slug}`)
    },
    initChart() {
      this.formatData()
      if (!this.noData) {
        const chartElement = this.createElement('reviews-by-rating-by-month-chart')
        this.chart.setColor(['#EC654E', '#F8D169', '#74CA78'])
        this.chart.setCategories(this.categories)
        this.chart.setSeries(this.formattedData)
        this.chartInstance = new ApexChart(chartElement, this.chart.options)
        this.chartInstance.render()
      }
    },
    createElement(ref) {
      let elem = document.getElementById(ref)
      let chartElement = document.createElement('div')
      chartElement = elem.appendChild(chartElement)
      chartElement.setAttribute('id', `${ref}-apex`)
      return chartElement
    },
    formatData() {
      let formattedData = [
        {
          name: this.resolveMoodLabelBySlug('negative'),
          data: []
        },
        {
          name: this.resolveMoodLabelBySlug('neutral'),
          data: []
        },
        {
          name: this.resolveMoodLabelBySlug('positive'),
          data: []
        }
      ]

      this.data.forEach((d) => {
        const date = `${this.$t(`global.months.${d.month}`)} ${d.year}`
        if (!this.categories.includes(date)) {
          this.categories.push(date)
        }
      })

      this.categories.forEach((date) => {
        const positiveMoodIndex = this.data.findIndex(
          (d) => `${this.$t(`global.months.${d.month}`)} ${d.year}` === date && d.mood === 'positive'
        )
        const neutralMoodIndex = this.data.findIndex(
          (d) => `${this.$t(`global.months.${d.month}`)} ${d.year}` === date && d.mood === 'neutral'
        )
        const negativeMoodIndex = this.data.findIndex(
          (d) => `${this.$t(`global.months.${d.month}`)} ${d.year}` === date && d.mood === 'negative'
        )

        formattedData[2].data.push(positiveMoodIndex > -1 ? this.data[positiveMoodIndex].reviews_number : 0)
        formattedData[1].data.push(neutralMoodIndex > -1 ? this.data[neutralMoodIndex].reviews_number : 0)
        formattedData[0].data.push(negativeMoodIndex > -1 ? this.data[negativeMoodIndex].reviews_number : 0)
      })

      this.formattedData = formattedData
    }
  }
}
</script>
